import React, { useEffect } from "react";
import ModalWrapper from "./ModalWrapper";
import $ from "jquery";

const SuccessPage = () => {
  useEffect(()=>{
    setTimeout(function () {
      $('#UPIAuthForm').submit();
  }, 4000);
    
  })
  return (
    <>
      <ModalWrapper>
      <div className="failed-wrapper">
        <div className="failed-container">
          <div className="failedScreen">
            <img
              src={`../../${process.env.PUBLIC_URL}/images/success.gif`}
              alt="success-GIF"
            />
            <p className="failedheading">Payment Successful</p>
            <p className="failedSubLine">
              Your Payment is successful,
              <br />
              Thank You
            </p>
          </div>
        </div>
        </div>
      </ModalWrapper>
    </>
  );
};

export default SuccessPage;
